module.exports = __webpack_public_path__ + "static/media/mb_logo.7e02ad7c.png";